export enum AgencySettingKey {
  PageTitle = 'PageTitle',
  IconUrl = 'IconUrl',
  PrivacyPolicyLink = 'PrivacyPolicyLink',
  TermsAndConditionsLink = 'TermsAndConditionsLink',
  WebSiteUrl = 'WebSiteUrl',
  ContactUsUrl = 'ContactUsUrl',
  LogoUrl = 'LogoUrl',
}

export type AgencySettings = Record<string, string | null>;

export interface AgencySettingsResponse {
  agencyId: number;
  customerId: number;
  slug: string;
  settings: AgencySettings;
}
